import {IconProps, darkGray, gray, red, white} from './shared';

export const Terrible = ({selected}: IconProps) => {
  const backgroundColor = selected ? red : gray;
  const foregroundColor = selected ? darkGray : white;
  const backgroundOpacity = selected ? '1.0' : '0.7';

  return (
    <svg
      width="43"
      height="40"
      viewBox="0 0 43 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.5 20C41.5 31.0457 32.5457 40 21.5 40C10.4543 40 1.5 31.0457 1.5 20C1.5 8.9543 10.4543 0 21.5 0C32.5457 0 41.5 8.9543 41.5 20Z"
        fill={backgroundColor}
        fillOpacity={backgroundOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5939 27.985C16.1444 28.4972 14.8899 29.1109 14.2008 29.5047C13.6014 29.8472 12.8379 29.6389 12.4953 29.0395C12.1528 28.4401 12.3611 27.6766 12.9605 27.334C13.7768 26.8676 15.1674 26.1909 16.761 25.6279C18.3418 25.0693 20.2156 24.5887 21.9677 24.5887C23.7199 24.5887 25.5937 25.0693 27.1745 25.6279C28.768 26.1909 30.1587 26.8676 30.975 27.334C31.5744 27.6766 31.7827 28.4401 31.4401 29.0395C31.0976 29.6389 30.3341 29.8472 29.7347 29.5047C29.0456 29.1109 27.7911 28.4972 26.3416 27.985C24.8794 27.4684 23.3124 27.0887 21.9677 27.0887C20.6231 27.0887 19.0561 27.4684 17.5939 27.985Z"
        fill={foregroundColor}
      />
      <path
        d="M17.4516 13.5806C17.4516 12.6667 16.2786 11 12.7595 11C11.5865 11 11 12.5484 11 13.5806C11 14.871 12.173 16.8065 13.9326 16.8065C15.6921 16.8065 17.4516 15.5161 17.4516 13.5806Z"
        fill={foregroundColor}
      />
      <path
        d="M26.4839 13.5806C26.4839 12.6667 27.6569 11 31.176 11C32.349 11 32.9355 12.5484 32.9355 13.5806C32.9355 14.871 31.7625 16.8065 30.0029 16.8065C28.2434 16.8065 26.4839 15.5161 26.4839 13.5806Z"
        fill={foregroundColor}
      />
    </svg>
  );
};
